import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4027_35366)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.75065 7.00065C10.0398 7.00065 11.084 5.95648 11.084 4.66732C11.084 3.37815 10.0398 2.33398 8.75065 2.33398C7.46148 2.33398 6.41732 3.37815 6.41732 4.66732C6.41732 5.95648 7.46148 7.00065 8.75065 7.00065ZM8.75065 3.50065C9.39232 3.50065 9.91732 4.02565 9.91732 4.66732C9.91732 5.30898 9.39232 5.83398 8.75065 5.83398C8.10898 5.83398 7.58398 5.30898 7.58398 4.66732C7.58398 4.02565 8.10898 3.50065 8.75065 3.50065ZM8.75065 8.16732C7.19315 8.16732 4.08398 8.94898 4.08398 10.5007V11.6673H13.4173V10.5007C13.4173 8.94898 10.3082 8.16732 8.75065 8.16732ZM5.25065 10.5007C5.37898 10.0807 7.18148 9.33398 8.75065 9.33398C10.3257 9.33398 12.134 10.0865 12.2507 10.5007H5.25065ZM3.50065 8.75065V7.00065H5.25065V5.83398H3.50065V4.08398H2.33398V5.83398H0.583984V7.00065H2.33398V8.75065H3.50065Z",
			fill: "#E8EAED"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4027_35366",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export { SvgAddUser as ReactComponent };
